import './index.scss'
import '../../assets/styles/language.css'
import '../../assets/scripts/trp-frontend-language-switcher.js'
import '../../assets/scripts/trp-language-cookie.js'
$("header").addClass("head1");
$(".hamburger").click(function(){
    $(this).toggleClass("active");
    $(".mob-nav").toggleClass("active");
})
$("header .nav li").hover(function(){
    $("header .nav li dl").stop().slideUp()
    $(this).find("dl").stop().slideDown()
}
,function(){
    $(this).find("dl").hide()
})
$(".mob-nav .nLi").click(function() {
    $(this).find(".sub").slideToggle();
    $(this).toggleClass("active");
})
 

if ($(window).scrollTop() >= ($("header").height())) {
    $("header").addClass("head1");
} else {
    $("header").removeClass("head1");
}

$(function () {
    $(window).scroll(function () {
        // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式
        if ($(window).scrollTop() >= ($("header").height())) {
            $("header").addClass("head1");
        } else {
            $("header").removeClass("head1");
        }
    })
})